// extracted by mini-css-extract-plugin
export default {"wrapper":"TiltedCard_wrapper__3QjDb"};